import BaseCollection from './base_collection';
import Merchant from './merchant';

// App.Collections.PopularMerchants
export default BaseCollection.extend({
  url: '/stores/popular_merchants.json',
  model: Merchant
});
